/**
 * Content Tabs Init
 */

(() => {
  const contentTabs = document.querySelector('.module-content-tabs');
  if (!contentTabs) return;

  if (!document.querySelector('.js-content-tab')) {
    console.warn('There are no indivdual tabs. Please add at least one "Content Tabs - Individual Tab" widget to the layout.');
    return;
  }

  const tabTitles = [];
  const tabContent = [];

  document.querySelectorAll('.js-content-tab').forEach((tab, id) => {
    const title = tab.querySelector('.data-tab-title')?.innerHTML || 'Placeholder Title';
    const icon = tab.querySelector('.data-tab-icon')?.textContent || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-icon-pencil.svg';
    const tabTitle = document.createElement('div');
    tabTitle.classList.add('tab-title');
    tabTitle.setAttribute('tab-id', id);
    tabTitle.setAttribute('tabindex', '0');
    tabTitle.innerHTML = /* html */`
      <div class="tab-icon">
        <img src="${icon}" alt="">
      </div>
      ${title}
    `;
    tabTitles.push(tabTitle);

    const content = tab.querySelector('.js-tab');
    if (!content) return;

    content.setAttribute('tab-id', id);
    tabContent.push(content);
  });

  contentTabs.querySelector('.tab-title-wrap').innerHTML = '';
  tabTitles.forEach((item) => {
    contentTabs.querySelector('.tab-title-wrap').append(item);
  });

  contentTabs.querySelector('.js-tabbed-content').innerHTML = '';
  tabContent.forEach((item) => {
    contentTabs.querySelector('.js-tabbed-content').append(item);
  });
})();
